import { render, staticRenderFns } from "./EinstellungenDozent.vue?vue&type=template&id=06981099&"
import script from "./EinstellungenDozent.vue?vue&type=script&lang=js&"
export * from "./EinstellungenDozent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports